import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "10",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("rect", {
      width: "2.25",
      height: "9",
      x: "8",
      y: "7.75",
      fill: "currentColor",
      rx: "1"
    }, null, -1),
    _createElementVNode("rect", {
      width: "2.25",
      height: "9",
      x: "13.5",
      y: "7.75",
      fill: "currentColor",
      rx: "1"
    }, null, -1)
  ])))
}
export default { render: render }